// Auto-generated grading candidates. Prices = median consensus (eBay sold + PriceCharting).
// biz=true: profit even on a PSA 9 (9-ROI = psa9/(rawNM+grading) >= 1.6). suspect=true: raw NM looks like a bad match.
export const GRADING_CARDS = [
  {
    "name": "Charizard GX",
    "set": "Burning Shadows",
    "number": "150",
    "era": "SM",
    "tier": "premium",
    "gem": "tough",
    "why": "'First rainbow Zard', deep buyer pool, strong multiplier",
    "rawNM": 420.0,
    "psa9": 751.5,
    "psa10": 6600,
    "mult": 15.7,
    "nineRoi": 1.7,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Umbreon ex",
    "set": "Prismatic Evolutions",
    "number": "161",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "#1 modern chase. Eeveelution demand; even PSA9 ~$1500. Textured SIR, screen centering",
    "rawNM": 1450.01,
    "psa9": 1635.53,
    "psa10": 6149.33,
    "mult": 4.2,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Reshiram ex",
    "set": "White Flare",
    "number": "174/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $5,107 (2025)",
    "rawNM": 330,
    "psa9": 362.31,
    "psa10": 773.0,
    "mult": 2.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gardevoir ex",
    "set": "Generations",
    "number": "RC30",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $5,000 (2016)",
    "rawNM": 70.0,
    "psa9": 198.75,
    "psa10": 2610.75,
    "mult": 37.3,
    "nineRoi": 2.1,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Umbreon VMAX",
    "set": "Evolving Skies",
    "number": "215/203",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "'Moonbreon', hobby #1 chase. Notorious centering, only submit dead-center",
    "rawNM": 1997.73,
    "psa9": 2247,
    "psa10": 4600.0,
    "mult": 2.3,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Alakazam ex",
    "set": "Fates Collide",
    "number": "125",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $4,183 (None)",
    "rawNM": 119.62,
    "psa9": 470.0,
    "psa10": 3737.5,
    "mult": 31.2,
    "nineRoi": 3.2,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Pikachu ex",
    "set": "Ascended Heroes",
    "number": "276/217",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $4,750 (None)",
    "rawNM": 1223.61,
    "psa9": 1200.0,
    "psa10": 3650,
    "mult": 3.0,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew ex",
    "set": "Paldean Fates",
    "number": "232",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $4,000 (2024)",
    "rawNM": 892.88,
    "psa9": 981.0,
    "psa10": 3708.5,
    "mult": 4.2,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gyarados ex",
    "set": "BREAKpoint",
    "number": "123/122",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $3,400 (None)",
    "rawNM": 156.33,
    "psa9": 430,
    "psa10": 2995.89,
    "mult": 19.2,
    "nineRoi": 2.4,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Mega Charizard X ex",
    "set": "Phantasmal Flames",
    "number": "130/94",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,650 (None)",
    "rawNM": 342.0,
    "psa9": 416.12,
    "psa10": 2975.5,
    "mult": 8.7,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Giratina V",
    "set": "Lost Origin",
    "number": "186/196",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "Top-3 SwSh alt art, elite liquidity, dark surface scrutiny",
    "rawNM": 700.0,
    "psa9": 900.5,
    "psa10": 3125.5,
    "mult": 4.5,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Gengar ex",
    "set": "Ascended Heroes",
    "number": "284/217",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $3,300 (2026)",
    "rawNM": 1301.42,
    "psa9": 1275.0,
    "psa10": 3085,
    "mult": 2.4,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Rayquaza VMAX",
    "set": "Evolving Skies",
    "number": "218",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "Iconic alt art, holo scratch risk, deep demand",
    "rawNM": 993.04,
    "psa9": 1164.54,
    "psa10": 2850.0,
    "mult": 2.9,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gengar VMAX",
    "set": "Fusion Strike",
    "number": "271/264",
    "era": "SwSh",
    "tier": "premium",
    "gem": "TRAP",
    "why": "Black bg shows every scratch, sub-20% gem. Big multiplier, high risk",
    "rawNM": 897.08,
    "psa9": 973.63,
    "psa10": 2649.95,
    "mult": 3.0,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Charizard X ex",
    "set": "Phantasmal Flames",
    "number": "125",
    "era": "Mega",
    "tier": "premium",
    "gem": "tough",
    "why": "Mega SIR, top Phantasmal Flames chase, Charizard liquidity",
    "rawNM": 900.64,
    "psa9": 899.0,
    "psa10": 2436,
    "mult": 2.7,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Dragonite ex",
    "set": "Ascended Heroes",
    "number": "290/217",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $2,200 (2026)",
    "rawNM": 862.79,
    "psa9": 815,
    "psa10": 2204.5,
    "mult": 2.6,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Sylveon ex",
    "set": "Generations",
    "number": "RC21",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $2,200 (2016)",
    "rawNM": 76.55,
    "psa9": 184,
    "psa10": 2200,
    "mult": 28.7,
    "nineRoi": 1.8,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Gardevoir ex",
    "set": "Steam Siege",
    "number": "116",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $2,000 (2016)",
    "rawNM": 87.52,
    "psa9": 193.41,
    "psa10": 1457.08,
    "mult": 16.6,
    "nineRoi": 1.7,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Zekrom ex",
    "set": "Black Bolt",
    "number": "172",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,925 (None)",
    "rawNM": 532.33,
    "psa9": 546.78,
    "psa10": 1743,
    "mult": 3.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard GX",
    "set": "Hidden Fates",
    "number": "SV49",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,850 (2019)",
    "rawNM": 545.75,
    "psa9": 655,
    "psa10": 1749.28,
    "mult": 3.2,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard ex",
    "set": "Pokemon 151",
    "number": "199",
    "era": "SV",
    "tier": "premium",
    "gem": "TRAP",
    "why": "Huge demand but ~28% gem (centering nightmare). Only grade dead-center copies",
    "rawNM": 405.0,
    "psa9": 440.0,
    "psa10": 1675,
    "mult": 4.1,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mewtwo",
    "set": "Hidden Fates",
    "number": "SM214",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $700 (2023)",
    "rawNM": 9.04,
    "psa9": 52.45,
    "psa10": 950.0,
    "mult": 105.1,
    "nineRoi": 1.5,
    "biz": false,
    "suspect": true
  },
  {
    "name": "Sylveon ex",
    "set": "Prismatic Evolutions",
    "number": "156",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Eeveelution halo, 2nd behind Umbreon",
    "rawNM": 406,
    "psa9": 431.94,
    "psa10": 1699.5,
    "mult": 4.2,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Lugia V",
    "set": "Silver Tempest",
    "number": "186/195",
    "era": "SwSh",
    "tier": "premium",
    "gem": "moderate",
    "why": "Silver Tempest hero card, big multiplier off mid raw",
    "rawNM": 487.5,
    "psa9": 573.12,
    "psa10": 1500,
    "mult": 3.1,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu ex",
    "set": "Ascended Heroes",
    "number": "277",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,400 (2026)",
    "rawNM": 508.99,
    "psa9": 525.0,
    "psa10": 1650,
    "mult": 3.2,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mewtwo ex",
    "set": "Destined Rivals",
    "number": "231",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,625 (2025)",
    "rawNM": 557.5,
    "psa9": 551.0,
    "psa10": 1425.5,
    "mult": 2.6,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Rayquaza V",
    "set": "Evolving Skies",
    "number": "194",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,800 (None)",
    "rawNM": 380.0,
    "psa9": 495.0,
    "psa10": 1545,
    "mult": 4.1,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon ex",
    "set": "Prismatic Evolutions",
    "number": "155",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,599 (2025)",
    "rawNM": 289.0,
    "psa9": 296.69,
    "psa10": 1287.5,
    "mult": 4.5,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Lugia GX",
    "set": "Lost Thunder",
    "number": "207",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,525 (None)",
    "rawNM": 123.8,
    "psa9": 183.0,
    "psa10": 1499.49,
    "mult": 12.1,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon ex",
    "set": "BREAKpoint",
    "number": "117/122",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,500 (2016)",
    "rawNM": 66.0,
    "psa9": 199.79,
    "psa10": 1294.58,
    "mult": 19.6,
    "nineRoi": 2.2,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Reshiram ex",
    "set": "White Flare",
    "number": "173/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,493 (None)",
    "rawNM": 462.5,
    "psa9": 460,
    "psa10": 1493,
    "mult": 3.2,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Umbreon ex",
    "set": "Fates Collide",
    "number": "55",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,450 (2016)",
    "rawNM": 44.57,
    "psa9": 124.99,
    "psa10": 1600.0,
    "mult": 35.9,
    "nineRoi": 1.8,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Team Rocket's Mewtwo",
    "set": "Destined Rivals",
    "number": "231/182",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Top chase of blockbuster 2025 set, Rocket+Mewtwo demand",
    "rawNM": 562.01,
    "psa9": 551.0,
    "psa10": 1425.5,
    "mult": 2.5,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu ex",
    "set": "Prismatic Evolutions",
    "number": "277/217",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,400 (2026)",
    "rawNM": 287.67,
    "psa9": 312.5,
    "psa10": 1400,
    "mult": 4.9,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon ex",
    "set": "Prismatic Evolutions",
    "number": "157/131",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Eeveelution SIR, psychic-type chase, textured",
    "rawNM": 289.0,
    "psa9": 296.69,
    "psa10": 1343.25,
    "mult": 4.6,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Victini",
    "set": "Black Bolt",
    "number": "171",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,396 (2025)",
    "rawNM": 545.0,
    "psa9": 590,
    "psa10": 1398.94,
    "mult": 2.6,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Dragonite V",
    "set": "Evolving Skies",
    "number": "192/203",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,300 (None)",
    "rawNM": 450.0,
    "psa9": 499.5,
    "psa10": 1300,
    "mult": 2.9,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Victini",
    "set": "White Flare",
    "number": "172/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,299 (2025)",
    "rawNM": 500,
    "psa9": 522.49,
    "psa10": 1299,
    "mult": 2.6,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Umbreon V",
    "set": "Evolving Skies",
    "number": "189/203",
    "era": "SwSh",
    "tier": "premium",
    "gem": "moderate",
    "why": "Umbreon brand carries it, reliable $500 ceiling",
    "rawNM": 337.45,
    "psa9": 405,
    "psa10": 1247.49,
    "mult": 3.7,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon",
    "set": "Fusion Strike",
    "number": "SWSH174",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,200 (2021)",
    "rawNM": 173.35,
    "psa9": 199.49,
    "psa10": 988.27,
    "mult": 5.7,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu ex",
    "set": "Surging Sparks",
    "number": "238/191",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Set king, Pikachu liquidity unmatched. Textured, screen hard",
    "rawNM": 320.0,
    "psa9": 320,
    "psa10": 1149,
    "mult": 3.6,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Team Rocket's Mewtwo ex",
    "set": "Ascended Heroes",
    "number": "281",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,300 (2026)",
    "rawNM": 466.18,
    "psa9": 487.5,
    "psa10": 1150.5,
    "mult": 2.5,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Greninja ex",
    "set": "Twilight Masquerade",
    "number": "214",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $930 (2024)",
    "rawNM": 357.55,
    "psa9": 355,
    "psa10": 965.0,
    "mult": 2.7,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard V",
    "set": "Brilliant Stars",
    "number": "154/172",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,000 (2022)",
    "rawNM": 305.15,
    "psa9": 347.72,
    "psa10": 925.5,
    "mult": 3.0,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu & Zekrom GX",
    "set": "Team Up",
    "number": "184",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,000 (2019)",
    "rawNM": 205.8,
    "psa9": 220.33,
    "psa10": 821,
    "mult": 4.0,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard ex",
    "set": "Paldean Fates",
    "number": "234",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,000 (2024)",
    "rawNM": 320.0,
    "psa9": 318,
    "psa10": 932.02,
    "mult": 2.9,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Glaceon ex",
    "set": "Prismatic Evolutions",
    "number": "150/131",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $835 (2025)",
    "rawNM": 262.5,
    "psa9": 260.0,
    "psa10": 810.0,
    "mult": 3.1,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Leafeon ex",
    "set": "Prismatic Evolutions",
    "number": "144",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $1,000 (2025)",
    "rawNM": 319.99,
    "psa9": 330.5,
    "psa10": 935.5,
    "mult": 2.9,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Rayquaza GX",
    "set": "Celestial Storm",
    "number": "177/168",
    "era": "SM",
    "tier": "high",
    "gem": "tough",
    "why": "Premium ceiling, best $/grade in S&M when you land the 10",
    "rawNM": 261.44,
    "psa9": 234.0,
    "psa10": 1000,
    "mult": 3.8,
    "nineRoi": 0.8,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Umbreon GX",
    "set": "Hidden Fates",
    "number": "SV69",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $970 (None)",
    "rawNM": 256.97,
    "psa9": 266.02,
    "psa10": 970,
    "mult": 3.8,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Vaporeon ex",
    "set": "Prismatic Evolutions",
    "number": "149",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $960 (2025)",
    "rawNM": 255.0,
    "psa9": 280.22,
    "psa10": 972.5,
    "mult": 3.8,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Suicune GX",
    "set": "Lost Thunder",
    "number": "220",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $950 (2018)",
    "rawNM": 81.17,
    "psa9": 110.5,
    "psa10": 770,
    "mult": 9.5,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu",
    "set": "Paldean Fates",
    "number": "131",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $950 (2024)",
    "rawNM": 79.57,
    "psa9": 108.0,
    "psa10": 850,
    "mult": 10.7,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Raichu",
    "set": "Paldea Evolved",
    "number": "211/193",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $900 (2023)",
    "rawNM": 103.25,
    "psa9": 121.25,
    "psa10": 866.95,
    "mult": 8.4,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew ex",
    "set": "Pokemon 151",
    "number": "053",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $914 (2023)",
    "rawNM": 405.0,
    "psa9": 283.75,
    "psa10": 1259.5,
    "mult": 3.1,
    "nineRoi": 0.7,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Glaceon ex",
    "set": "Prismatic Evolutions",
    "number": "155/131",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Eeveelution SIR, ice-type fan demand",
    "rawNM": 259.89,
    "psa9": 264.09,
    "psa10": 854.5,
    "mult": 3.3,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Blaziken VMAX",
    "set": "Chilling Reign",
    "number": "201/198",
    "era": "SwSh",
    "tier": "premium",
    "gem": "moderate",
    "why": "Best Chilling Reign alt art, liquid",
    "rawNM": 340.07,
    "psa9": 362.11,
    "psa10": 837.5,
    "mult": 2.5,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Oshawott IR",
    "set": "White Flare",
    "number": "105/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $875 (None)",
    "rawNM": 81.0,
    "psa9": 79.55,
    "psa10": 678.0,
    "mult": 8.4,
    "nineRoi": 0.8,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu",
    "set": "Lost Origin",
    "number": "TG05",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $560 (None)",
    "rawNM": 58,
    "psa9": 90.47,
    "psa10": 797.5,
    "mult": 13.8,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon VMAX",
    "set": "Fusion Strike",
    "number": "270/264",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $800 (None)",
    "rawNM": 311.71,
    "psa9": 326.49,
    "psa10": 800,
    "mult": 2.6,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Shiny Charizard GX",
    "set": "Hidden Fates Shiny Vault",
    "number": "SV49/SV94",
    "era": "SM",
    "tier": "high",
    "gem": "tough",
    "why": "#1 SM chase, bulletproof liquidity, Charizard premium, textured border",
    "rawNM": 453.95,
    "psa9": 652.5,
    "psa10": 1274.64,
    "mult": 2.8,
    "nineRoi": 1.4,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard ex",
    "set": "Obsidian Flames",
    "number": "223",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Tera Charizard SIR, ~6.6x multiplier, Charizard liquidity absorbs misses",
    "rawNM": 119.18,
    "psa9": 159.99,
    "psa10": 780.0,
    "mult": 6.5,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Sylveon VMAX",
    "set": "Evolving Skies",
    "number": "212",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "#2 Eeveelution alt, Eevee-line centering issues",
    "rawNM": 383.97,
    "psa9": 385,
    "psa10": 750,
    "mult": 2.0,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Sylveon",
    "set": "Prismatic Evolutions",
    "number": "040",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $760 (None)",
    "rawNM": 1.97,
    "psa9": 28.6,
    "psa10": 244.49,
    "mult": 124.1,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": true
  },
  {
    "name": "Hoothoot TG",
    "set": "Astral Radiance",
    "number": "TG12",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $750 (None)",
    "rawNM": 8.49,
    "psa9": 42.31,
    "psa10": 675,
    "mult": 79.5,
    "nineRoi": 1.3,
    "biz": false,
    "suspect": true
  },
  {
    "name": "Roaring Moon ex",
    "set": "Prismatic Evolutions",
    "number": "162",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $750 (2025)",
    "rawNM": 174.15,
    "psa9": 185.0,
    "psa10": 763.06,
    "mult": 4.4,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Vanilluxe",
    "set": "White Flare",
    "number": "113/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $750 (None)",
    "rawNM": 33.99,
    "psa9": 29.76,
    "psa10": 262.5,
    "mult": 7.7,
    "nineRoi": 0.5,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Flareon ex",
    "set": "Prismatic Evolutions",
    "number": "146",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $750 (2025)",
    "rawNM": 170.13,
    "psa9": 205,
    "psa10": 691.05,
    "mult": 4.1,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Cynthia ex",
    "set": "Destined Rivals",
    "number": "232/182",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $750 (2025)",
    "rawNM": 261.64,
    "psa9": 274.99,
    "psa10": 650,
    "mult": 2.5,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Jolteon ex",
    "set": "Prismatic Evolutions",
    "number": "153/131",
    "era": "SV",
    "tier": "premium",
    "gem": "tough",
    "why": "Eeveelution SIR, electric-type chase",
    "rawNM": 172.5,
    "psa9": 200,
    "psa10": 650.0,
    "mult": 3.8,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Glaceon ex",
    "set": "Fates Collide",
    "number": "116",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $740 (2016)",
    "rawNM": 25.56,
    "psa9": 82.9,
    "psa10": 734.5,
    "mult": 28.7,
    "nineRoi": 1.6,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Charizard ex",
    "set": "XY Evolutions",
    "number": "101/108",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $730 (2016)",
    "rawNM": 140.0,
    "psa9": 180.0,
    "psa10": 732.5,
    "mult": 5.2,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew",
    "set": "Crown Zenith",
    "number": "GG10",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $729 (2023)",
    "rawNM": 69.01,
    "psa9": 97.25,
    "psa10": 669.5,
    "mult": 9.7,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard ex",
    "set": "XY Evolutions",
    "number": "101",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $726 (None)",
    "rawNM": 136.49,
    "psa9": 175.0,
    "psa10": 735.0,
    "mult": 5.4,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard",
    "set": "Unbroken Bonds",
    "number": "217/214",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $720 (2019)",
    "rawNM": 190.1,
    "psa9": 214.46,
    "psa10": 720,
    "mult": 3.8,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gardevoir ex",
    "set": "Steam Siege",
    "number": "112/114",
    "era": "XY",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $710 (2016)",
    "rawNM": 55.0,
    "psa9": 99,
    "psa10": 487.5,
    "mult": 8.9,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew",
    "set": "Pokemon 151",
    "number": "168",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $705 (2023)",
    "rawNM": 106.37,
    "psa9": 138.6,
    "psa10": 684.7,
    "mult": 6.4,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Leafeon VMAX",
    "set": "Evolving Skies",
    "number": "205/203",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "Mid-tier Eeveelution alt, reliable demand",
    "rawNM": 340.0,
    "psa9": 350.0,
    "psa10": 660,
    "mult": 1.9,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mewtwo VSTAR",
    "set": "Crown Zenith",
    "number": "GG44",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $700 (2023)",
    "rawNM": 292.15,
    "psa9": 311.9,
    "psa10": 680.44,
    "mult": 2.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Psyduck",
    "set": "Ascended Heroes",
    "number": "226/217",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $700 (None)",
    "rawNM": 104.97,
    "psa9": 184.25,
    "psa10": 700,
    "mult": 6.7,
    "nineRoi": 1.4,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gastly",
    "set": "Temporal Forces",
    "number": "177",
    "era": "SV",
    "tier": "premium",
    "gem": "easy",
    "why": "Top IR in set, 45% gem, Gengar-line demand, huge premium",
    "rawNM": 107.91,
    "psa9": 125.0,
    "psa10": 654.43,
    "mult": 6.1,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Charizard Y ex",
    "set": "Ascended Heroes",
    "number": "294/217",
    "era": "Mega",
    "tier": "premium",
    "gem": "tough",
    "why": "Gold Mega Hyper Rare, Charizard premium",
    "rawNM": 621.8,
    "psa9": 779.5,
    "psa10": 3233.0,
    "mult": 5.2,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Zekrom ex",
    "set": "Black Bolt",
    "number": "174/86",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $677 (2025)",
    "rawNM": 311.03,
    "psa9": 336.5,
    "psa10": 735.94,
    "mult": 2.4,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mega Starmie ex",
    "set": "Perfect Order",
    "number": "118",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $675 (2026)",
    "rawNM": 66.88,
    "psa9": 90,
    "psa10": 473.5,
    "mult": 7.1,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "BLASTOISE ex",
    "set": "Pokemon 151",
    "number": "200",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $675 (2023)",
    "rawNM": 150.0,
    "psa9": 177.5,
    "psa10": 655,
    "mult": 4.4,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Espeon V",
    "set": "Evolving Skies",
    "number": "195/203",
    "era": "SwSh",
    "tier": "mid",
    "gem": "moderate",
    "why": "Best multiplier on list: ~$70 raw -> ~$675 PSA10",
    "rawNM": 200.0,
    "psa9": 214.57,
    "psa10": 635.36,
    "mult": 3.2,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Gengar",
    "set": "Lost Origin",
    "number": "TG06",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $650 (None)",
    "rawNM": 57.78,
    "psa9": 96.31,
    "psa10": 664.5,
    "mult": 11.5,
    "nineRoi": 1.2,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Eevee ex",
    "set": "Prismatic Evolutions",
    "number": "167/131",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $680 (2025)",
    "rawNM": 180.0,
    "psa9": 185.04,
    "psa10": 660,
    "mult": 3.7,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu V",
    "set": "Lost Origin",
    "number": "TG16",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $560 (None)",
    "rawNM": 120.5,
    "psa9": 140.0,
    "psa10": 520.0,
    "mult": 4.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Marnie ex",
    "set": "Ascended Heroes",
    "number": "287",
    "era": "Mega",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $650 (2026)",
    "rawNM": 79.99,
    "psa9": 119.05,
    "psa10": 310.0,
    "mult": 3.9,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Shiny Charizard ex",
    "set": "Paldean Fates",
    "number": "234/091",
    "era": "SV",
    "tier": "high",
    "gem": "moderate",
    "why": "44% gem (well above 151 trap), top hobby liquidity, shiny-vault stock grades clean",
    "rawNM": 319.33,
    "psa9": 317.5,
    "psa10": 774.0,
    "mult": 2.4,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Cynthia's Garchomp ex",
    "set": "Destined Rivals",
    "number": "232/182",
    "era": "SV",
    "tier": "premium",
    "gem": "moderate",
    "why": "Cynthia trainer SIR, strong demand",
    "rawNM": 265.82,
    "psa9": 274.99,
    "psa10": 649,
    "mult": 2.4,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Glaceon VMAX",
    "set": "Evolving Skies",
    "number": "209/203",
    "era": "SwSh",
    "tier": "premium",
    "gem": "tough",
    "why": "Popular Eeveelution alt, centering caveat",
    "rawNM": 279.86,
    "psa9": 300.0,
    "psa10": 640,
    "mult": 2.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew ex",
    "set": "Pokemon 151",
    "number": "191",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $643 (2025)",
    "rawNM": 198.68,
    "psa9": 248.36,
    "psa10": 639.77,
    "mult": 3.2,
    "nineRoi": 1.1,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Mew ex",
    "set": "Pokemon 151",
    "number": "200",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $640 (2023)",
    "rawNM": 148.9,
    "psa9": 176.8,
    "psa10": 633.04,
    "mult": 4.3,
    "nineRoi": 1.0,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charmander",
    "set": "Pokemon 151",
    "number": "168/165",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $635 (2023)",
    "rawNM": 32.16,
    "psa9": 137.2,
    "psa10": 635,
    "mult": 19.7,
    "nineRoi": 2.4,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Dragonite GX",
    "set": "Unified Minds",
    "number": "248/236",
    "era": "SM",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $630 (None)",
    "rawNM": 118.53,
    "psa9": 134.38,
    "psa10": 725.58,
    "mult": 6.1,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Moltres V",
    "set": "Chilling Reign",
    "number": "177",
    "era": "SwSh",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $630 (2021)",
    "rawNM": 200.0,
    "psa9": 213.32,
    "psa10": 564.35,
    "mult": 2.8,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Pikachu",
    "set": "Pokemon 151",
    "number": "173",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $625 (2023)",
    "rawNM": 42.49,
    "psa9": 105.5,
    "psa10": 599.99,
    "mult": 14.1,
    "nineRoi": 1.6,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Zekrom ex",
    "set": "Black Bolt",
    "number": "166",
    "era": "SV",
    "tier": "premium",
    "gem": "",
    "why": "Real eBay-sold PSA10 $619 (2025)",
    "rawNM": 250.0,
    "psa9": 255.56,
    "psa10": 599.99,
    "mult": 2.4,
    "nineRoi": 0.9,
    "biz": false,
    "suspect": false
  },
  {
    "name": "Charizard",
    "set": "XY Evolutions",
    "number": "11/108",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($218) = 1.9x your all-in cost",
    "rawNM": 90,
    "psa9": 218,
    "psa10": 2100,
    "mult": 23.3,
    "nineRoi": 1.9,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Gengar",
    "set": "Generations",
    "number": "35/83",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($202) = 3.4x your all-in cost",
    "rawNM": 35,
    "psa9": 202,
    "psa10": 2466,
    "mult": 70.5,
    "nineRoi": 3.4,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Charizard",
    "set": "Generations",
    "number": "RC5/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($104) = 1.7x your all-in cost",
    "rawNM": 37,
    "psa9": 104,
    "psa10": 1925,
    "mult": 52.0,
    "nineRoi": 1.7,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Flareon EX",
    "set": "Generations",
    "number": "RC28/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($2530) = 17.4x your all-in cost",
    "rawNM": 120,
    "psa9": 2530,
    "psa10": 30350,
    "mult": 252.9,
    "nineRoi": 17.4,
    "biz": false,
    "suspect": true
  },
  {
    "name": "Flareon EX",
    "set": "Generations",
    "number": "RC6/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($200) = 2.5x your all-in cost",
    "rawNM": 55,
    "psa9": 200,
    "psa10": 1825,
    "mult": 33.2,
    "nineRoi": 2.5,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Sylveon EX",
    "set": "Generations",
    "number": "RC32/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($445) = 4.7x your all-in cost",
    "rawNM": 70,
    "psa9": 445,
    "psa10": 5000,
    "mult": 71.4,
    "nineRoi": 4.7,
    "biz": true,
    "suspect": false
  },
  {
    "name": "M Gardevoir EX",
    "set": "Generations",
    "number": "RC31/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($250) = 2.0x your all-in cost",
    "rawNM": 98,
    "psa9": 250,
    "psa10": 3074,
    "mult": 31.4,
    "nineRoi": 2.0,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Pikachu",
    "set": "Generations",
    "number": "RC29/RC32",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($415) = 3.3x your all-in cost",
    "rawNM": 100,
    "psa9": 415,
    "psa10": 5499,
    "mult": 55.0,
    "nineRoi": 3.3,
    "biz": true,
    "suspect": false
  },
  {
    "name": "M Charizard EX",
    "set": "Generations",
    "number": "12/83",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($324) = 2.0x your all-in cost",
    "rawNM": 137,
    "psa9": 324,
    "psa10": 3025,
    "mult": 22.1,
    "nineRoi": 2.0,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Umbreon EX",
    "set": "Fates Collide",
    "number": "119/124",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($317) = 2.3x your all-in cost",
    "rawNM": 115,
    "psa9": 317,
    "psa10": 2999,
    "mult": 26.1,
    "nineRoi": 2.3,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Gyarados EX",
    "set": "BREAKpoint",
    "number": "114/122",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($175) = 1.9x your all-in cost",
    "rawNM": 68,
    "psa9": 175,
    "psa10": 1025,
    "mult": 15.1,
    "nineRoi": 1.9,
    "biz": true,
    "suspect": false
  },
  {
    "name": "M Gyarados EX",
    "set": "BREAKpoint",
    "number": "115/122",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($226) = 2.1x your all-in cost",
    "rawNM": 82,
    "psa9": 226,
    "psa10": 1199,
    "mult": 14.6,
    "nineRoi": 2.1,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Ho-Oh EX",
    "set": "BREAKpoint",
    "number": "121/122",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($141) = 2.4x your all-in cost",
    "rawNM": 35,
    "psa9": 141,
    "psa10": 682,
    "mult": 19.5,
    "nineRoi": 2.4,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Mewtwo EX",
    "set": "BREAKthrough",
    "number": "157/162",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($210) = 3.1x your all-in cost",
    "rawNM": 42,
    "psa9": 210,
    "psa10": 1562,
    "mult": 37.2,
    "nineRoi": 3.1,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Mewtwo EX",
    "set": "BREAKthrough",
    "number": "163/162",
    "era": "XY",
    "tier": "high",
    "gem": "",
    "why": "Business card: even a PSA 9 ($377) = 1.8x your all-in cost",
    "rawNM": 179,
    "psa9": 377,
    "psa10": 3849,
    "mult": 21.5,
    "nineRoi": 1.8,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Mewtwo EX",
    "set": "BREAKthrough",
    "number": "164/162",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($425) = 3.9x your all-in cost",
    "rawNM": 85,
    "psa9": 425,
    "psa10": 4200,
    "mult": 49.4,
    "nineRoi": 3.9,
    "biz": true,
    "suspect": false
  },
  {
    "name": "M Mewtwo EX",
    "set": "BREAKthrough",
    "number": "159/162",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($283) = 2.1x your all-in cost",
    "rawNM": 107,
    "psa9": 283,
    "psa10": 2000,
    "mult": 18.7,
    "nineRoi": 2.1,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Gengar",
    "set": "BREAKthrough",
    "number": "60/162",
    "era": "XY",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($208) = 3.6x your all-in cost",
    "rawNM": 32,
    "psa9": 208,
    "psa10": 2349,
    "mult": 73.4,
    "nineRoi": 3.6,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Rayquaza GX",
    "set": "Celestial Storm",
    "number": "160/168",
    "era": "SM",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($240) = 2.8x your all-in cost",
    "rawNM": 60,
    "psa9": 240,
    "psa10": 994,
    "mult": 16.6,
    "nineRoi": 2.8,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Charizard",
    "set": "Team Up",
    "number": "14/181",
    "era": "SM",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($150) = 2.7x your all-in cost",
    "rawNM": 30,
    "psa9": 150,
    "psa10": 600,
    "mult": 20.0,
    "nineRoi": 2.7,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Snorlax",
    "set": "Unbroken Bonds",
    "number": "158/214",
    "era": "SM",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($189) = 2.4x your all-in cost",
    "rawNM": 55,
    "psa9": 189,
    "psa10": 1925,
    "mult": 35.0,
    "nineRoi": 2.4,
    "biz": true,
    "suspect": false
  },
  {
    "name": "Shining Rayquaza",
    "set": "Shining Legends",
    "number": "56/73",
    "era": "SM",
    "tier": "mid",
    "gem": "",
    "why": "Business card: even a PSA 9 ($225) = 2.0x your all-in cost",
    "rawNM": 85,
    "psa9": 225,
    "psa10": 1401,
    "mult": 16.5,
    "nineRoi": 2.0,
    "biz": true,
    "suspect": false
  }
];

export default GRADING_CARDS;
